<template>
	<div class="d-flex sp-wrapper justify-content-center align-items-center vh-100">
		<span
			class="spinner-border spinner-icon"
			role="status"
			aria-hidden="true"></span>
	</div>
</template>

<script>
export default {
	name: "SOLoadSearch",
}
</script>

<style scoped>
.sp-wrapper {
  margin-top: -100px;
}

.spinner-icon{
  color: #C8D0DD;
  width: 72px;
  height: 72px;
}
</style>